const currencyCountryMapping = {
  USD: ['US'],
  CAD: ['CA'],
  AUD: ['AU'],
  GBP: ['GB'],
  CZK: ['CZ'],
  EUR: ['DE', 'LT'],
  HKD: ['HK'],
  SGD: ['SG'],
};

const currencyClearingMapping = {
  USD: ['ACH', 'FEDWIRE'],
  CAD: [],
  AUD: ['BANK_TRANSFER', 'BPAY'],
  GBP: ['FASTER_PAYMENTS'],
  SGD: ['FAST', 'GIRO', 'RTGS'],
};

module.exports = {
  currencyCountryMapping,
  currencyClearingMapping,
};
